import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import React, { FC } from 'react';
import { AiOutlineDropbox } from 'react-icons/ai';
import { BsCurrencyDollar } from 'react-icons/bs';
import { FaBox, FaInbox, FaUsers } from 'react-icons/fa';
import { FiShoppingCart } from 'react-icons/fi';
import { IoHomeOutline, IoNewspaperOutline, IoPricetag } from 'react-icons/io5';
import { MdOutlinePrecisionManufacturing } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Hooks/Auth';

interface MenuProps {
  open: boolean;
  onClose: () => void;
}

interface MakeButtonProps {
  title: string;
  LeftIcon: () => JSX.Element; 
  action: () => void;
}

export interface PermissionsScreens {
  [menu:string]: string;
  // menu:collaborators?: string;
  // menu:customers?: string;
  // menu:categories?: string;
  // menu:orders?: string;
  // menu:replacementOrders?: string;
  // menu:productsServices?: string;
  // menu:boxes?: string;
  // menu:cubages?: string;
  // menu:products?: string;
  // menu:production?: string;
  // menu:financial?: string;
  // menu:stocks?: string;
  // menu:pricePolicies?: string
}


const Menu: FC<MenuProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const navigate = useNavigate()
  const { user } = useAuth()


  const hasPermission = (permission: keyof PermissionsScreens) => {
    return user?.permissionsScreens?.includes(`${permission}:manage`)
  };

  const sections = [
    {
      title: 'Geral',
      items: [
        { title: 'Home', action: () => navigate('/dashboard'), icon: () => <IoHomeOutline size={18} color={theme.palette.text.secondary} /> },
        ...(hasPermission('menu:sellers') ? [{ title: 'Vendedores', action: () => navigate('/sellers-list'), icon: () => <FaUsers size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:collaborators') ? [{ title: 'Colaboradores', action: () => navigate('/collaborators-list'), icon: () => <FaUsers size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:customers') ? [{ title: 'Clientes', action: () => navigate('/customers-list'), icon: () => <FaUsers size={18} color={theme.palette.text.secondary} /> }] : []),
        // ...(hasPermission('categories') ? [{ title: 'Categorias / Marcas', action: () => navigate('/categories-list'), icon: () => <IoNewspaperOutline size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:orders') ? [{ title: 'Pedidos', action: () => navigate('/orders-list'), icon: () => <IoNewspaperOutline size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:replacementOrders') ? [{ title: 'Pedidos Reposição', action: () => navigate('/orders-replacement-list'), icon: () => <IoNewspaperOutline size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:productsServices') ? [{ title: 'Serviços', action: () => navigate('/services-list'), icon: () => <IoNewspaperOutline size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:boxes') ? [{ title: 'Caixas', action: () => navigate('/box-list'), icon: () => <AiOutlineDropbox size={21} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:cubages') ? [{ title: 'Cubagem', action: () => navigate('/cubage-list'), icon: () => <FaBox size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:products') ? [{ title: 'Produtos', action: () => navigate('/products-list'), icon: () => <FiShoppingCart size={18} color={theme.palette.text.secondary} /> }] : []),
        // ...(hasPermission('pricePolicies') ? [{ title: 'Política de Preços', action: () => navigate('/prices-list'), icon: () => <FiShoppingCart size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:products') ? [{ title: 'Política de Preços', action: () => navigate('/price-policies-list'), icon: () => <IoPricetag size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:stocks') ? [{ title: 'Estoque', action: () => navigate('/stocks-list'), icon: () => <FaInbox size={18} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:production') ? [{ title: 'Produção', action: () => navigate('/production-list'), icon: () => <MdOutlinePrecisionManufacturing size={20} color={theme.palette.text.secondary} /> }] : []),
        ...(hasPermission('menu:financial') ? [{ title: 'Financeiro', action: () => navigate('/financial-list'), icon: () => <BsCurrencyDollar size={20} color={theme.palette.text.secondary} /> }] : [])
      ],
    },
    // {
    //     title: 'Configurações',
    //   items: [
    //     { title: 'Configurações', icon: () => <FaChevronUp size={18} color={theme.palette.text.secondary} /> },
    //     { title: 'Sobre', icon: () => <FaChevronDown size={18} color={theme.palette.text.secondary} /> },
    //   ],
    // },
  ];

  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    onClose();
  };

  const list = () => (
    <Box
      sx={{ width: 350 }}
      role="presentation"
      onClick={toggleDrawer}
      onKeyDown={toggleDrawer}
    >
      {sections.map((section) => (
        <List key={section.title}>
          {section.items.map((item) => (
            <ListItem key={item.title}>
              <ListItemButton
                onClick={item.action}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(132, 168, 2, 0.3)',
                    '& .MuiTypography-root': {
                      color: theme.palette.primary.dark
                    },
                  },
                }}
              >
                <ListItemIcon>
                  {item.icon()}
                </ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      ))}
    </Box>
  );

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
    >
      {list()}
    </SwipeableDrawer>
  );
}

export { Menu };
